import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	height: fit-content;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	position: sticky;
	top: 4rem;
	z-index: 10;
	padding: 0;
	padding-bottom: 1rem;
	margin-bottom: -2.5rem;
	gap: 1rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		padding-bottom: 2.5rem;
		justify-content: center;
	}
`;
